import { immerOn } from 'ngrx-immer/store';
import {
  resetContractTypeFilter,
  setContractTypeFilter,
  setContractTypeFilterBasedOnUrlValue,
} from './contract-type.actions';
import { availableContractTypeOptions } from './contract-type.state';
import { resetAllFilters } from '../filter.actions';
import { updateFilterConfiguration } from '../policy/filter-configuration.reducer';
import {
  ContractTypeFilterState,
  ContractTypeOption,
  FilterState,
} from '@immosky/types';

export const initialContractTypeState: ContractTypeFilterState = {
  options: availableContractTypeOptions,
  filter: availableContractTypeOptions[0],
  default: availableContractTypeOptions[0],
};

export const contractTypeReducers = [
  immerOn(setContractTypeFilter, (state: FilterState, { filter }) => {
    updateContractType(state, filter);
  }),
  immerOn(resetContractTypeFilter, resetAllFilters, (state: FilterState) => {
    updateContractType(state, state.contractType.default);
  }),
  immerOn(
    setContractTypeFilterBasedOnUrlValue,
    (state: FilterState, { value }) => {
      const option = availableContractTypeOptions.find(
        (o) => o.value === value
      );

      if (option) {
        updateContractType(state, option);
      }
    }
  ),
];

export function updateContractType(
  state: FilterState,
  contractType: ContractTypeOption
) {
  state.contractType.filter = contractType;
  updateFilterConfiguration(state);
}
